import styled from '@emotion/styled'
import {
  Button,
  BUTTON_VARIANT_SECONDARY,
  Grid,
  GridCell,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
  Text,
  TEXT_VARIANT_BOLD
} from 'mailup-web-components'
import PropTypes from 'prop-types'

import { useIntl } from 'react-intl'

const getFilterTypeLabel = (type) => {
  switch (type) {
    case 'Anagraphic':
      return 'Load.SearchRecipients.ProfileFilter'
    case 'Activity':
      return 'Load.SearchRecipients.ActivityFilter'
    case 'Device':
      return 'Load.SearchRecipients.DeviceFilter'
    case 'Geolocation':
      return 'Load.SearchRecipients.GeolocationFilter'
    case 'Engagement':
      return 'Load.SearchRecipients.EngagementFilter'
    default:
      return 'Load.Common.Filter'
  }
}

const Description = styled.div`
  word-wrap: break-word;
`

const ModalFilterDetails = ({
  show,
  id,
  name,
  type,
  description,
  canEdit,
  onClose,
  onEdit
}) => {
  const intl = useIntl()

  return (
    <Modal showClose closeOnOverlayClick show={show} onClose={onClose}>
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.SearchRecipients.EditFilterFilterTitle'
        })}
      />

      <ModalBody>
        <Grid cols={12}>
          {type && (
            <>
              <GridCell span={3}>
                <Text variant={TEXT_VARIANT_BOLD}>
                  {intl.formatMessage({
                    id: 'Load.SearchRecipients.EditFilterFilterType'
                  })}
                </Text>
              </GridCell>
              <GridCell span={9}>
                {intl.formatMessage({ id: getFilterTypeLabel(type) })}
              </GridCell>
            </>
          )}

          <GridCell span={3}>
            <Text variant={TEXT_VARIANT_BOLD}>
              {intl.formatMessage({
                id: 'Load.SearchRecipients.EditFilterFilterName'
              })}
            </Text>
          </GridCell>
          <GridCell span={9}>
            {id} - {name}
          </GridCell>

          <GridCell span={3}>
            <Text variant={TEXT_VARIANT_BOLD}>
              {intl.formatMessage({
                id: 'Load.SearchRecipients.EditFilterFilterConditions'
              })}
            </Text>
          </GridCell>
          <GridCell span={9}>
            <Description>{description}</Description>
          </GridCell>
        </Grid>
      </ModalBody>
      <ModalFoot>
        <Button kind={BUTTON_VARIANT_SECONDARY} onClick={onClose}>
          {intl.formatMessage({
            id: 'Load.SearchRecipients.EditFilterCloseButton'
          })}
        </Button>
        {canEdit && (
          <Button kind={BUTTON_VARIANT_SECONDARY} onClick={onEdit}>
            {intl.formatMessage({
              id: 'Load.SearchRecipients.EditFilterEditButton'
            })}
          </Button>
        )}
      </ModalFoot>
    </Modal>
  )
}

ModalFilterDetails.defaultProps = {
  show: false,
  canEdit: false
}

ModalFilterDetails.propTypes = {
  show: PropTypes.bool,
  canEdit: PropTypes.bool,
  id: PropTypes.number,
  name: PropTypes.string,
  description: PropTypes.string,
  type: PropTypes.oneOf([
    'Anagraphic',
    'Activity',
    'Device',
    'Geolocation',
    'Engagement'
  ]),
  onClose: PropTypes.func,
  onEdit: PropTypes.func
}

export default ModalFilterDetails
